import { render, staticRenderFns } from "./waitingDep.vue?vue&type=template&id=b82355f4&scoped=true&"
import script from "./waitingDep.vue?vue&type=script&lang=js&"
export * from "./waitingDep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82355f4",
  null
  
)

export default component.exports